export default __webpack_public_path__ + "static/bottle_shadow-caa2c707e2c895d2a3b9ae4020ab3b42.png";